// MX Size Recommender – SAFE MODE
(() => {
  const modal = document.getElementById('SizeRecommenderModal');
  if (!modal) return;

  const openModal = () => modal.setAttribute('aria-hidden', 'false');
  const closeModal = () => modal.setAttribute('aria-hidden', 'true');

  // Allow other scripts (mx-size.js / mx-dropdown.js) to open this modal safely.
  window.addEventListener('mx:open-size-recommender', () => {
    requestAnimationFrame(openModal);
  });

  modal.addEventListener('click', (e) => {
    if (e.target.closest('[data-sr-close]')) closeModal();
  });

  // Find ONLY the Size select (avoid color, etc.)
  function getSizeSelect() {
    // Dawn typical
    let sel =
      document.querySelector('variant-selects select[name="options[Size]"]') ||
      document.querySelector('select[name="options[Size]"]') ||
      document.querySelector('select[data-option-name="Size"]');

    // fallback: any options select that contains "Size recommender"
    if (!sel) {
      const candidates = [...document.querySelectorAll('variant-selects select, select[name^="options["]')];
      sel = candidates.find(s =>
        [...s.options].some(o => /size recommender/i.test(o.value) || /size recommender/i.test(o.text))
      );
    }
    return sel || null;
  }

  let lastValidValue = null;

  function isRecommenderOption(valueOrText) {
    return /size recommender/i.test(String(valueOrText || ''));
  }

  // CAPTURE listener to stop Dawn from processing invalid variant
  document.addEventListener('change', (e) => {
    const sizeSelect = getSizeSelect();
    if (!sizeSelect || e.target !== sizeSelect) return;

    const v = sizeSelect.value;
    const selectedOptionText = sizeSelect.options[sizeSelect.selectedIndex]?.text || '';

    if (isRecommenderOption(v) || isRecommenderOption(selectedOptionText)) {
      e.stopImmediatePropagation(); // prevent Dawn variant update
      e.preventDefault();

      // revert to last valid size (or placeholder)
      if (lastValidValue !== null) {
        sizeSelect.value = lastValidValue;
      } else {
        sizeSelect.selectedIndex = 0;
      }

      // trigger a clean change so theme stays consistent
      sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));

      // open modal after DOM settles
      requestAnimationFrame(openModal);
      return;
    }

    // store last valid selection
    lastValidValue = v;
  }, true); // <- CAPTURE = key safety point

  // Simple recommender logic placeholder (you'll tune to chart)
  const calcBtn = document.getElementById('sr-calc');
  const applyBtn = document.getElementById('sr-apply');
  const resultBox = document.getElementById('sr-result');

  let recommendedSize = null;

  calcBtn?.addEventListener('click', () => {
    const h = Number(document.getElementById('sr-height')?.value);
    const w = Number(document.getElementById('sr-weight')?.value);
    const fit = document.getElementById('sr-fit')?.value || 'regular';

    if (!h || !w) return;

    let rec = 'M';
    if (h < 165 || w < 60) rec = 'S';
    if (h >= 180 || w >= 80) rec = 'L';
    if (h >= 190 || w >= 95) rec = 'XL';

    if (fit === 'relaxed') rec = nextSize(rec);
    if (fit === 'slim') rec = prevSize(rec);

    recommendedSize = rec;

    resultBox.hidden = false;
    resultBox.innerHTML = `<strong>Recommended size:</strong> ${rec}<br><span style="opacity:.7">Based on your inputs.</span>`;

    applyBtn.hidden = false;
  });

  applyBtn?.addEventListener('click', () => {
    const sizeSelect = getSizeSelect();
    if (!sizeSelect || !recommendedSize) return;

    sizeSelect.value = recommendedSize;
    lastValidValue = recommendedSize;
    sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    closeModal();
  });

  function nextSize(s){
    const order = ['XS','S','M','L','XL','1XL','2XL'];
    const i = order.indexOf(s);
    return order[Math.min(i+1, order.length-1)] || s;
  }
  function prevSize(s){
    const order = ['XS','S','M','L','XL','1XL','2XL'];
    const i = order.indexOf(s);
    return order[Math.max(i-1, 0)] || s;
  }
})();
